























import { Component, Mixins, Prop } from "vue-property-decorator";
import { FixedLoading } from "../system";
import { ExistingDocumentEditor } from "./editors";
import { DocumentEditViewMixin, DocumentParameterContainableMixin } from "./mixins";

@Component({
  components: {
    FixedLoading,
    ExistingDocumentEditor,
  },
})
export default class DocumentEditView extends Mixins(DocumentEditViewMixin, DocumentParameterContainableMixin) {
  @Prop()
  documentId: number;

  @Prop()
  orderNo: string;
}
